import { useSelector } from 'react-redux';
import { getBaccaratCards } from '../selectors';
import { ICardsSide } from '../interfaces/reducer.interfaces';

export const useGameCardsSide = (side: ICardsSide) => useSelector(getBaccaratCards(side));
